import React from "react";
import "./VaidikVidhya.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import CoursesSection from "../../pages/VaidikVidhya/CoursesSection";
import ServicesSection from "../../pages/VaidikVidhya/ServicesSection";
import CategoryButtons from "../../pages/VaidikVidhya/CategoryButtons";
import { FiHeadphones } from "react-icons/fi";
import Reviews from "../../components/Reviews/Reviews";
// import { Link } from "react-router-dom"; // used by the commented-out hero section
import consultationBanner from "../../assets/images/consultation-banner.webp";

const VaidikVidhya = () => {
  return (
    <>
      <Header />
      <section className="consultation-banner">
        <img
          src={consultationBanner}
          alt="Vaidik Vidhya - Professional Astrology Consultation"
        />
      </section>
      {/*
      <section className="vaidikHero-section">
        <div className="vaidikHero-overlay"></div>

        <div className="vaidikHero-container">
           Left Content 
          <div className="vaidikHero-content">
            <span className="vaidikHero-tag">
              ✨ Ancient Knowledge • Modern Guidance
            </span>

            <h1>
              Vaidik <span>Vidhya™</span>
            </h1>

            <p>
              Learn authentic Numerology, Vedic Astrology, Vastu Shastra and
              Spiritual Sciences from experienced mentors. Explore professional
              consultation services and discover spiritually energized products
              designed for prosperity, balance and success.
            </p>

            <div className="vaidikHero-buttons">
              <Link to="/course/numerology" className="vaidikHero-primaryBtn">
                Explore Courses
              </Link>

              <Link
                to="/service/kundli-reading"
                className="vaidikHero-secondaryBtn"
              >
                Book Consultation
              </Link>
            </div>
          </div>

           Right Image 
          <div className="vaidikHero-image">
            <img
              src={require("../../assets/images/vedik.png")}
              alt="Vaidik Vidhya"
            />
          </div>
        </div>
      </section>
      */}
      <ServicesSection />
      <CoursesSection />
      <Reviews showPhotos={false} />
      <CategoryButtons />
      <section className="support-section">
        <div className="support-content">
          <h2>Ready To Begin Your Spiritual Journey?</h2>
          <p>
            Learn from traditional wisdom, receive expert guidance and choose
            the right spiritual products according to your birth chart.
          </p>
          <button className="support-btn">
            <FiHeadphones />
            Contact Us
          </button>

        
        </div>
      </section>
      <Footer />
    </>
  );
};

export default VaidikVidhya;
